<script setup lang="ts">
import Menu from '../components/Menu.vue'

defineProps<{
  logoUrl?: string
  name?: string
  profileImgUrl?: string
}>()
</script>

<template>
  <Menu>
    <template #activator="{ toggle }">
      <button
        data-component="user_menu"
        class="relative flex items-center rounded-full border border-neutral-300 lg:space-x-3 lg:rounded-lg lg:border-neutral-200 lg:p-2 lg:py-1"
        data-analytics="top-bar-account-dropdown"
        @click="toggle()"
      >
        <div class="hidden flex-1 text-left lg:block">
          <img
            v-if="logoUrl"
            class="h-full max-h-5 w-full max-w-20"
            :src="logoUrl"
            alt="workspace logo"
          />
          <span
            v-if="name"
            class="max-w-40 truncate text-xs text-neutral-800"
            data-testid="userMenuWorkspaceName"
          >
            {{ name }}
          </span>
        </div>

        <div class="row-span-2">
          <div
            class="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-neutral-200"
          >
            <img
              v-if="profileImgUrl"
              class="absolute inset-0"
              :src="profileImgUrl"
              referrerpolicy="no-referrer"
            />
            <div v-else class="flex justify-center p-1">
              <div class="i-ph-user block h-6 w-6 text-neutral-500" />
            </div>
          </div>
        </div>
      </button>
    </template>
    <div
      v-if="name || logoUrl"
      class="flex items-center space-x-3 border-b border-neutral-200 px-3 py-2 lg:hidden"
      data-testid="userMenuWorkspaceMobileHeader"
    >
      <img
        v-if="logoUrl"
        class="h-5 max-w-20 object-contain"
        :src="logoUrl"
        alt="workspace logo"
      />
      <span v-if="name" class="subtitle-2 truncate text-neutral-800">
        {{ name }}
      </span>
    </div>
    <slot>
      <ul class="flex flex-col p-2">
        <li>
          <RouterLink
            to="/settings"
            class="user-menu-link"
            active-class="bg-primary-light text-white"
          >
            Settings
          </RouterLink>
        </li>
        <li>
          <button class="user-menu-link">Log out</button>
        </li>
      </ul>
    </slot>
  </Menu>
</template>

<style scoped>
.user-menu-link {
  @apply inline-flex w-full rounded-lg px-4 py-2 text-left text-sm font-light hover:bg-neutral-100 hover:text-neutral-800;
}
</style>
